import "@/App.css";
import { Router, Route, Switch } from "wouter";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Products from "@/pages/Products";
import GiftCards from "@/pages/GiftCards";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancelled from "@/pages/PaymentCancelled";
import AdminDashboard from "@/pages/AdminDashboard";
import Login from "@/pages/Login";
import Share from "@/pages/Share";
import NotFound from "@/pages/NotFound";

const ADMIN_PATH = process.env.REACT_APP_ADMIN_SECRET_PATH || "admin-secret-path";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Router>
          <Switch>
            {/* Auth & admin — no public layout */}
            <Route path="/login" component={Login} />
            <Route path="/share" component={Share} />
            <Route path={`/${ADMIN_PATH}`}>
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            </Route>

            <Route>
              <Layout>
                <Switch>
                  <Route path="/" component={Home} />
                  <Route path="/services" component={Services} />
                  <Route path="/about" component={About} />
                  <Route path="/products" component={Products} />
                  <Route path="/gift-cards" component={GiftCards} />
                  <Route path="/payment/success" component={PaymentSuccess} />
                  <Route path="/payment/cancelled" component={PaymentCancelled} />
                  <Route component={NotFound} />
                </Switch>
              </Layout>
            </Route>
          </Switch>
        </Router>
      </AuthProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
